import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseDataService } from './base-data-service';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import {
  SecurityUserGroupRequest,
  SecurityUserGroupResponse,
  SubCompany
} from './def/claim-subcompany';
import { has } from 'libs/util/has-value';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { GlobalVariablesService } from './global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityUserGroupService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    public loaderService: LoaderService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  subCompanyCached: SubCompany[];
  SecurityUserGroupRequest: SecurityUserGroupRequest;

  setSubCompanyMapper(data: SecurityUserGroupResponse) {
    if (
      !data ||
      !has(data, 'MemberOfGroupCollection') ||
      !has(data.MemberOfGroupCollection[0], 'GrantedMenuCollection') ||
      data.MemberOfGroupCollection[0].GrantedMenuCollection[0].MenuName !=
        'Login to Subcompany'
    ) {
      // throw new Error(
      //   'Login to Subcompany should be setup for the user before use it.'
      // );
      this.subCompanyCached = null;
    } else {
      this.subCompanyCached = data.MemberOfGroupCollection[0].GrantedMenuCollection.find(
        a => a.MenuName == 'Login to Subcompany'
      ).SubCompaniesCollection;
    }
  }
  filterSubCompany(subCompanyCode) {
    if (this.subCompanyCached && this.subCompanyCached.length > 0) {
      this.loaderService.show();
      return this.subCompanyCached.find(
        subComp => subComp.SubCompanyCode === subCompanyCode
      );
    } else {
      throw new Error('Sub Company list is fetched before used');
    }
  }
  async fetchSubCompany() {
    let param = {
      EmailId: sessionStorage.getItem('UserId'),
      // EmailId: 'aichan@tmhcc.com',
      SubCompanyCode: '',
      Components: ['Login to SubCompany']
    };

    const url = `${this.serviceBaseUrl}/SecurityUserGroupPermissions`;
    await this.post<SecurityUserGroupResponse>(url, { body: param }, false)
      .toPromise()
      .then(data => {
        this.setSubCompanyMapper(data);
      });
    return this.subCompanyCached;
  }

  get subCompanyData() {
    if (!this.subCompanyCached) {
      throw new Error(
        'Sub Company data must be fetched before it can be used.'
      );
    }

    return this.subCompanyCached;
  }
}
